export interface Testimonial {
  id: number;
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export interface StatItem {
  label: string;
  value: string;
  icon: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: '',
    rating: 5,
    content: '韩漫大全真的是我看过最好的韩国漫画平台！更新速度快，画质清晰，而且完全免费无删减。自从发现这个网站后，每天都忍不住上来追更新！',
    date: '2026-07-15',
  },
  {
    id: 2,
    name: '小猫咪爱吃鱼',
    avatar: '',
    rating: 5,
    content: '从朋友那里知道韩漫官方网址的，没想到有这么多好看的韩国漫画。分类很详细，找漫画特别方便。强烈推荐给喜欢韩漫的朋友！',
    date: '2026-07-20',
  },
  {
    id: 3,
    name: '夜雨声烦',
    avatar: '',
    rating: 5,
    content: '用了很多漫画APP，最后还是回到了韩漫大全。界面简洁流畅，最重要的是资源真的很全，我在别的地方找不到的冷门韩漫这里都有！',
    date: '2026-07-25',
  },
  {
    id: 4,
    name: '晨曦微露',
    avatar: '',
    rating: 5,
    content: '作为韩漫的老读者，我可以说韩漫大全的翻译质量是最高的。很多细节都翻译到位了，阅读体验非常好。已经推荐给身边所有喜欢看漫画的朋友了。',
    date: '2026-07-28',
  },
  {
    id: 5,
    name: '追风少年',
    avatar: '',
    rating: 4,
    content: '好看的韩国漫画APP果然名不虚传！更新及时，画质清晰，而且支持离线缓存，在地铁上也能愉快看漫画。唯一的建议是希望能增加评论互动功能。',
    date: '2026-07-30',
  },
  {
    id: 6,
    name: '小确幸',
    avatar: '',
    rating: 5,
    content: '从闺蜜那里听说这个韩国漫画平台，一试就爱上了！无删减漫画免费在线观看真的太好了，很多在其他平台被删减的内容这里都有完整版。我的宝藏网站！',
    date: '2026-08-01',
  },
];

export const stats: StatItem[] = [
  { label: '漫画作品', value: '10,000+', icon: 'ri-book-open-line' },
  { label: '日活跃用户', value: '500,000+', icon: 'ri-user-heart-line' },
  { label: '累计阅读量', value: '5亿+', icon: 'ri-eye-line' },
  { label: '用户好评率', value: '98.5%', icon: 'ri-thumb-up-line' },
];

export const milestones = [
  { year: '2018', event: '韩漫大全平台正式上线，开启韩国漫画在线阅读新时代' },
  { year: '2019', event: '漫画作品数量突破1,000部，用户突破10万' },
  { year: '2020', event: '推出好看韩国漫画APP，实现移动端全覆盖' },
  { year: '2021', event: '与韩国多家顶级漫画工作室达成独家合作' },
  { year: '2022', event: '平台作品数量突破5,000部，日活用户突破30万' },
  { year: '2023', event: '获得年度最佳漫画阅读平台奖，用户好评率达98%' },
  { year: '2024', event: '全面升级无删减漫画免费在线观看服务，用户体验大幅提升' },
  { year: '2025', event: '平台漫画作品突破10,000部，成为中文韩漫第一平台' },
];

export const faqs = [
  {
    question: '韩漫大全是什么？',
    answer: '韩漫大全是一个专注于韩国漫画的在线阅读平台，通过韩漫官方网址即可访问。我们提供海量的无删减韩国漫画免费在线观看服务，涵盖恋爱、动作、奇幻、悬疑、搞笑等多种类型，是中文用户观看韩国漫画的最佳选择。',
  },
  {
    question: '如何在韩漫大全免费在线观看漫画？',
    answer: '访问韩漫官方网址即可开始阅读。您可以通过分类浏览或搜索功能找到喜欢的漫画，点击进入详情页后即可免费在线观看所有章节。我们还提供好看韩国漫画APP，下载后可以在手机上随时随地畅享阅读体验。',
  },
  {
    question: '韩漫大全的漫画是否无删减？',
    answer: '是的！韩漫大全承诺所有漫画均为无删减版本，与原版韩国漫画内容完全一致。我们尊重创作者的原始表达，让读者能够完整体验每一部漫画的精彩内容。无删减漫画免费在线观看是我们的核心承诺。',
  },
  {
    question: '韩漫大全是否需要付费？',
    answer: '韩漫大全目前完全免费！我们提供无删减漫画免费在线观看服务，所有漫画都可以免费阅读，无需任何付费订阅。下载好看韩国漫画APP同样免费，让您随时随地畅享韩国漫画。',
  },
  {
    question: '韩漫大全的更新频率如何？',
    answer: '我们与韩国漫画工作室保持紧密合作，确保漫画更新与原版同步或仅延迟1-2天。热门漫画通常每周更新，部分作品甚至每日更新。您可以通过韩漫官方网址或好看韩国漫画APP第一时间获取最新章节。',
  },
];